import {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  ICreateCheckoutSessionRequest
} from "../../compiled";
import {useRpcSender} from "../../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import {useSearchParams} from "react-router-dom";

export const useCreateCheckoutSessionRpc = () => {
  
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})

  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('v') === 'DRAFT'

  const send = (request: ICreateCheckoutSessionRequest) => {

    if (isPreview) {
      setRpcState({state: 'error', message: 'Booking is disabled in preview mode.'});
      return;
    }

    setRpcState({state: 'pending'})
    rpcSender.send('create_checkout_session', CreateCheckoutSessionRequest.encode(request).finish())
        .then(r => {
          let response = CreateCheckoutSessionResponse.decode(r);

          // Since this URL redirects to stripe to log in, we want to REPLACE it so the user
          // goes back another page in the checkout session.
          window.location.replace(response.clientSecret);
        })
        .catch(e => {
          console.log('Error booking.. ', e);
          setRpcState({state: 'error', message: 'Server error booking class!'});
        });
  }
  
  return {rpcState, send}
}